module.exports = __webpack_public_path__ + "assets/img/0a8a513d3dcd007f2c8027ebe618186d.png";